import React, { useState, useEffect, useContext } from 'react';


import OverlayPanelTemplate from '../../../Base/Components/Overlays/OverlayPanelTemplate';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';

import { ListadoOrdenesCompraAuth } from '../../../API/Compras/Requisas/PurchareDetailsRequests';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';

const ItemOverlayPanel = ({selectedItemChange, overlayItemRef, IdPurchaseOrderDetail, IdComponent,   IdProveedor,
    IdMoneda,
    IsPro,}) => {

    const { userAuth } = useContext(AuthContext);

    const [ordenesCompraAuth, setOrdenesCompraAuth] = useState([]);
    const [loading, setLoading] = useState(false);

    const obtenerListadoOrdenes = async() => {
        setLoading(true);
        const tempo = await ListadoOrdenesCompraAuth();
        const filteredData = tempo.filter((item) => {
          return (
            (!IdProveedor || item.IdProveedor === IdProveedor) &&
            (!IdMoneda || item.IdCurrency === IdMoneda)
          );
        });
  
        setOrdenesCompraAuth(IsPro ? filteredData : tempo);
        setLoading(false);
    }
    
    useEffect(() => {
        obtenerListadoOrdenes();
    }, [IdProveedor, IdMoneda, IsPro]);

    const Columns = [
        {
            field: 'IdPurcharesRequestDetail',
            header: 'ID',
            className: "Xsmall",
            alignFrozen: "left",
            frozen: "frozen",
            hidden: userAuth.IdRol === 1,
        },
        {
            // REQUISA
            field: 'PurchaseRequest',
            header: 'Requisa',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // PRODUCTO
            field: 'NombreProducto',
            header: 'Producto',
            className: "large",
            sortable: true,
            filter: true
        },
        {
            // CATEGORIA
            field: 'NombreCategoria',
            header: 'Categoria',
            className: "medium",
            sortable: true,
            filter: true
        },
        {
            // TIPO
            field: 'NombreTipo',
            header: 'Tipo',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // ORDEN DE VENTA
            field: 'IdSalesOrder',
            header: 'Orden de venta',
            className: "medium",
            sortable: true,
            filter: true
        },
        {
            // PRECIO
            field: 'Price',
            header: 'Precio',
            Format: 'Currency',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // MONEDA
            field: 'CurrencySymbol',
            header: 'Moneda',
            className: "XXsmall",
            Format: 'Center',
            sortable: true,
            filter: true
        },
        {
            // CANTIDAD
            field: 'Quantity',
            header: 'Cantidad',
            Format: 'Currency',
            className: "small",
            sortable: true,
            filter: true
        },
        {
            // UNIDAD
            field: 'UnitSimbol',
            header: 'Unidad',
            className: "XXsmall",
            Format: 'Center',
            sortable: true,
            filter: true
        },
        {
            // SUBTOTAL
            field: 'SubTotal',
            header: 'SubTotal',
            className: "small",
            Format: 'Currency',
            sortable: true,
            filter: true
        },
        {
            // DESCUENTO
            field: 'Descuento',
            header: 'Descuento',
            className: "small",
            Format: 'Currency',
            sortable: true,
            filter: true
        },
        {
            // TOTAL
            field: 'Total',
            header: 'Total',
            className: "small",
            Format: 'Currency',
            sortable: true,
            filter: true
        },

    ]

    const table = {
        Data: ordenesCompraAuth,
        Columns: Columns,
        editMode: 'cell',
        loading: loading,
        onCellClicked: e => selectedItemChange(e, IdPurchaseOrderDetail)
    };

    const overlayContent = (
        <div style={{ height: 300 }}>
            <AgGrid styles={{ maxHeight: '100px' }} table={table} />
        </div>
    )

    return (
        <div>
            <OverlayPanelTemplate
                InputValue={IdComponent}
                overlayRef={overlayItemRef}
                overlayContent={overlayContent}
                dismissable={false}
                styles={{
                    height: '33%',
                    width: "65%"
                 }}
            />
        </div>
    )
}

export default ItemOverlayPanel